export default __webpack_public_path__ + "static/cer-8-aa656a69d89a63106d0caf165ae75f3e.webp";